export default __webpack_public_path__ + "media/src/javascripts/containers/red_marker-f96aeb96221d91a36e2a19301f4db31a.svg";